import React from "react";
import { Typography, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import "@ckeditor/ckeditor5-build-classic/build/translations/fa";
import CheckBox from "@jumbo/Dashboards/Banner/CheckBox";
import { useSelector, useDispatch } from "react-redux";
import { setFormSettings } from "redux/actions/FormBuilder";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import "@ckeditor/ckeditor5-build-classic/build/translations/fa";

const useStyles = makeStyles((theme) => ({
  textFieldLabel: {
    color: theme.palette.primary.main,
    marginBottom: "16px",
    fontWeight: "bold",
  },
  formControl: {
    width: "100%",
  },
}));

const ConfirmMessage = () => {
  const classes = useStyles();

  const { formSettings } = useSelector(({ formBuilder }) => formBuilder);
  const dispatch = useDispatch();

  const {
    customSMSMessageEnabled,
    customSMSMessage,
    customFormMessageEnabled,
    customFormMessage,
  } = formSettings;

  return (
    <>
      <Grid item xs={12}>
        <CheckBox
          name={"sms"}
          title={"پیامک شخصی سازی شده"}
          value={customSMSMessageEnabled}
          handleChange={() =>
            dispatch(
              setFormSettings({
                ...formSettings,
                customSMSMessageEnabled: !customSMSMessageEnabled,
              })
            )
          }
        />
      </Grid>
      <Grid item xs={12}>
        <Typography className={classes.textFieldLabel}>توضیحات</Typography>
        <CKEditor
          editor={ClassicEditor}
          config={{
            language: "fa",
            toolbar: [
              "heading",
              "|",
              "bold",
              "italic",
              "link",
              "bulletedList",
              "numberedList",
              "blockQuote",
            ],
            link: {
              addTargetToExternalLinks: true,
              defaultTarget: "_blank",
            },
          }}
          data={customSMSMessage}
          onChange={(_, editor) => {
            const data = editor.getData();
            dispatch(
              setFormSettings({ ...formSettings, customSMSMessage: data })
            );
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <CheckBox
          name={"message"}
          title={"پیام فرم شخصی سازی شده"}
          value={customFormMessageEnabled}
          handleChange={() =>
            dispatch(
              setFormSettings({
                ...formSettings,
                customFormMessageEnabled: !customFormMessageEnabled,
              })
            )
          }
        />
      </Grid>
      <Grid item xs={12}>
        <Typography className={classes.textFieldLabel}>توضیحات</Typography>
        <CKEditor
          editor={ClassicEditor}
          config={{
            language: "fa",
            toolbar: [
              "heading",
              "|",
              "bold",
              "italic",
              "link",
              "bulletedList",
              "numberedList",
              "blockQuote",
            ],
            link: {
              addTargetToExternalLinks: true,
              decorators: [
                {
                  mode: "manual",
                  label: "باز کردن در تب جدید",
                  attributes: {
                    target: "_blank",
                  },
                },
              ],
            },
          }}
          data={customFormMessage}
          onChange={(_, editor) => {
            const data = editor.getData();
            dispatch(
              setFormSettings({ ...formSettings, customFormMessage: data })
            );
          }}
        />
      </Grid>
    </>
  );
};

export default ConfirmMessage;
